import { render, staticRenderFns } from "./EFTPopup.vue?vue&type=template&id=6677840a&scoped=true&"
import script from "./EFTPopup.vue?vue&type=script&lang=js&"
export * from "./EFTPopup.vue?vue&type=script&lang=js&"
import style0 from "./EFTPopup.vue?vue&type=style&index=0&id=6677840a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6677840a",
  null
  
)

export default component.exports